import type { Venue } from '../../types/venue';

export const falkenbergStrandbad: Venue = {
  id: 'falkenberg-strandbad',
  name: 'Falkenberg Strandbad',
  description: {
    en: `<p>Right on the beach at Skrea Strand lies Falkenberg Strandbad, which can be viewed from all across the long sandy beach. Sunbathe and enjoy a beautiful spring and summer day or feel the winds and the ocean's forces during autumn and winter. Each season has its special charm at this fantastic hotel. Falkenberg Strandbad is a cashless hotel.</p>
    
    <p>When you arrive at Falkenberg Strandbad for a conference, meeting, kickoff, party, or grand dinner – you know you're in safe hands. We direct your event together with you, so that you get exactly what you want from your stay. How about dinner à la Sandy's Grill, a day in our Pool Club, or an After Beach when the agenda has been checked off?</p>
    
    <p>The possibilities are endless at this west coast pearl – just 55 minutes from Gothenburg.</p>
    
    <p>The perfect combination of business and pleasure – brainstorming with elements of pool club.</p>`,
    
    sv: `<p>Alldeles nere vid stranden på Skrea Strand ligger Falkenberg Strandbad som går att betrakta överallt ifrån den långsträckta stranden. Sola och njut en vacker vår- och sommardag eller känn vindarna och havets krafter under hösten och vintern. Varje årstid har sin speciella charm på detta fantastiska hotell. Falkenberg Strandbad är ett kontantfritt hotell.</p>
    
    <p>När ni landar på Falkenberg Strandbad för en konferens, möte, kickoff, fest eller storslagen middag – så vet ni att ni är trygga händer. Vi regisserar ert event tillsammans med er, så att ni får ut precis det ni vill av vistelsen. Vad sägs om middag à la Sandy's Grill, en dag i vår Pool Club eller en After Beach när agendan blivit avbockad?</p>
    
    <p>Möjligheterna är oändliga på västkustens pärla – ynka 55 minuter från Göteborg.</p>
    
    <p>Den perfekta kombinationen av business and pleasure – brainstorming med inslag av pool club.</p>`,
    
    no: `<p>Helt nede på stranden ved Skrea Strand ligger Falkenberg Strandbad, som kan sees fra hele den lange sandstranden. Sol og nyt en vakker vår- og sommerdag eller føl vindene og havets krefter under høsten og vinteren. Hver årstid har sin spesielle sjarm på dette fantastiske hotellet. Falkenberg Strandbad er et kontantfritt hotell.</p>
    
    <p>Når dere lander på Falkenberg Strandbad for en konferanse, møte, kickoff, fest eller storslagen middag – så vet dere at dere er i trygge hender. Vi regisserer arrangementet sammen med dere, slik at dere får nøyaktig det dere ønsker fra oppholdet. Hva med middag à la Sandy's Grill, en dag i vår Pool Club eller en After Beach når agendaen er avkrysset?</p>`,
    
    da: `<p>Lige ved stranden på Skrea Strand ligger Falkenberg Strandbad, som kan ses fra hele den lange sandstrand. Solbad og nyd en smuk forårs- og sommerdag eller mærk vindene og havets kræfter under efteråret og vinteren. Hver årstid har sin særlige charme på dette fantastiske hotel. Falkenberg Strandbad er et kontantfrit hotel.</p>
    
    <p>Når I lander på Falkenberg Strandbad til en konference, møde, kickoff, fest eller storslået middag – så ved I, at I er i trygge hænder. Vi iscenesætter jeres arrangement sammen med jer, så I får præcis det, I ønsker ud af opholdet. Hvad med middag à la Sandy's Grill, en dag i vores Pool Club eller en After Beach, når dagsordenen er tjekket af?</p>`
  },
  image: '/assets/images/falkenberg.webp',
  country: 'se',
  region: 'west-coast',
  city: 'Falkenberg',
  address: 'Havsbadsallén 2A, 311 42 Falkenberg, Sweden',
  coordinates: {
    lat: 56.88864367374013,
    lng: 12.495212713535178
  },
  capacity: {
    min: 2,
    max: 160
  },
  rating: 4.7,
  reviews: Array.from({ length: 85 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.7,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'pool', 'spa', 'sauna'],
  images: [
    '/assets/images/falkenberg.webp',
  ],
  priceRange: {
    min: 2800,
    max: 20000
  },
  recommended: false,
  factbox: {
    rooms: 135,
    conferenceRooms: 14,
    meetingCapacity: 160,
    features: [
      '135 double rooms with 270 beds',
      '14 conference rooms',
      'Beachfront location at Skrea Strand',
      'Only 55 minutes from Gothenburg',
      'Sandy\'s Grill restaurant',
      'Pool Club',
      '24-hour reception',
      'Breakfast buffet',
      'Spa and wellness center',
      'Tennis courts',
      'Table tennis',
      'Mini-golf',
      'Indoor pool',
      'Sauna',
      'Massage services',
      'Free WiFi',
      'Cashless hotel'
    ]
  }
}; 